import { Button } from 'remote-com-shared/components/Button';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled from 'styled-components';

export const TitleComponent = styled.div`
  color: ${({ $textColor = 'var(--color-tone-font)' }) => $textColor};
  ${fluidProp('font-size', '34px', '56px')}
  font-family: var(--typography-fontBossa);
  font-weight: 500;
  line-height: 1.15;
  text-align: center;
  margin: 0 auto 32px;

  > * {
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    margin: inherit;
  }
`;
export const DescriptionComponent = styled.div`
  color: ${({ $textColor = 'var(--color-tone-font)' }) => $textColor};
  font-size: 20px;
  font-weight: 400;
  line-height: 1.4;
  text-align: center;
  margin: 0 auto 32px;

  > * {
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    margin: inherit;
  }
`;

export const CTAButton = styled(Button)`
  && {
    color: var(--color-tone-font);
    background: var(--color-tone-secondary);
    box-shadow: 0px 6px 12px var(--color-tone-secondary-shadow);
  }
`;
